const initialState = { expenses: null };

const expensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_EXPENSES":
      return {
        ...state,
        expenses: action.data,
      };

    case "CREATE_EXPENSES": {
      let dt = state.expenses.concat(action.data);
      return {
        ...state,
        expenses: dt,
      };
    }
    case "UPDATE_EXPENSES": {
      let dt = state.expenses.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        expenses: dt,
      }
    };
    case "DELETE_EXPENSES": {
      let dt = state.expenses.filter((a) => a._id !== action.data);
      return {
        ...state,
        expenses: dt,
      };
    }
    default:
      return state;
  }
};

export default expensesReducer;
